import { DatePipe } from "@angular/common";
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnInit
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { conformToMask } from "angular2-text-mask";
import { FormMaskConstants } from "src/app/constants/form-mask.constants";
import { ContactInfo } from "src/app/models/user/models";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppUtil } from "src/app/utils/app.util";

@Component({
	selector: "app-edit-contact-info",
	templateUrl: "./edit-contact-info.component.html",
	styleUrls: ["./edit-contact-info.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditContactInfoComponent implements OnInit {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public userStoreService: USERStoreService,
		private formBuilder: FormBuilder,
		public dmvStoreService: DMVStoreService,
		public userDataService: USERDataService,
		public megStoreService: MEGStoreService,
		public datepipe: DatePipe,
		private cd: ChangeDetectorRef
	) {}
	public submitted = false;
	public editContactForm: FormGroup;
	public errorMessage: string = "";
	public isOpenTerms = false;
	public isloading: boolean = false;
	public mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
	public phoneMask = FormMaskConstants.PHONE_MASK;

	ngOnInit() {
		let contactInfo: ContactInfo = Object.assign({});
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().contactInfo
		) {
			contactInfo = this.userStoreService.getUserProfile().contactInfo;
		}
		if (!contactInfo.address) {
			contactInfo.address = Object.assign({});
		}
		const dateOfBirth = new DatePipe("en-US").transform(
			contactInfo.dateOfBirth,
			"MM/dd/yyyy"
		);

		this.editContactForm = this.formBuilder.group({
			firstName: [
				contactInfo.firstName,
				[Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]
			],
			lastName: [contactInfo.lastName],
			phoneNumber: [contactInfo.phoneNumber],
			collectorCounty: [contactInfo.agencyID, Validators.required],
			mailingAddress: [contactInfo.address.line1],
			city: [contactInfo.address.city],
			mobile: [contactInfo.phoneNumber && contactInfo.mobile],
			state: [contactInfo.address.stateCode || "FL"],
			zip: [contactInfo.address.postalCode],
			dateOfBirth: [
				dateOfBirth,
				Validators.compose([
					Validators.pattern(
						/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
					),
					this.globalService.dateRangeValidator("max")
				])
			]
		});
		this.addressValidationCheck();
	}
	public get f() {
		return this.editContactForm.controls;
	}

	public toggleMobile() {
		if (!this.hasValue(this.editContactForm.controls.phoneNumber.value)) {
			this.editContactForm.controls.mobile.setValue(false);
		}
	}
	public cancel() {
		this.back();
	}
	public back() {
		this.router.navigate(["contact-info"], { skipLocationChange: true });
	}
	public save() {
		this.addressValidationCheck();
		this.errorMessage = "";
		this.submitted = true;
		if (this.editContactForm.invalid) {
			this.errorMessage = "Please correct fields in error.";
			console.log("changePassswordForm.invalid");
			return;
		}
		this.isloading = true;
		this.editAddress();
	}

	public addressValidationCheck() {
		if (
			this.hasValue(this.editContactForm.controls.mailingAddress.value) ||
			this.hasValue(this.editContactForm.controls.city.value) ||
			this.hasValue(this.editContactForm.controls.zip.value)
		) {
			this.editContactForm.controls.mailingAddress.setValidators([
				Validators.required
			]);
			this.editContactForm.controls.city.setValidators([Validators.required]);
			this.editContactForm.controls.state.setValidators([Validators.required]);
			this.editContactForm.controls.zip.setValidators([Validators.required]);
			if (!this.hasValue(this.editContactForm.controls.zip.value)) {
				this.editContactForm.controls.zip.setErrors({
					required: true
				});
			}
			if (!this.hasValue(this.editContactForm.controls.mailingAddress.value)) {
				this.editContactForm.controls.mailingAddress.setErrors({
					required: true
				});
			}
			if (!this.hasValue(this.editContactForm.controls.state.value)) {
				this.editContactForm.controls.state.setErrors({
					required: true
				});
			}
			if (!this.hasValue(this.editContactForm.controls.city.value)) {
				this.editContactForm.controls.city.setErrors({
					required: true
				});
			}
		} else {
			this.editContactForm.controls.mailingAddress.setValidators(null);
			this.editContactForm.controls.city.setValidators(null);
			this.editContactForm.controls.state.setValidators(null);
			this.editContactForm.controls.zip.setValidators(null);
			this.editContactForm.controls.mailingAddress.setErrors(null);
			this.editContactForm.controls.city.setErrors(null);
			this.editContactForm.controls.state.setErrors(null);
			this.editContactForm.controls.zip.setErrors(null);
		}
	}
	public hasValue(field) {
		if (field && field.trim() && field.trim().length > 0) {
			return true;
		} else {
			return false;
		}
	}
	public editAddress() {
		const request: ContactInfo = Object.assign({});
		request.emailAddress = this.userStoreService.getUserProfile().contactInfo.emailAddress;
		request.firstName = this.editContactForm.controls.firstName.value;
		request.lastName = this.editContactForm.controls.lastName.value;
		// request.phoneNumber = this.editContactForm.controls.phoneNumber.value;
		// request.phoneNumber = conformToMask(
		// 	this.editContactForm.controls.phoneNumber.value.replace(/\D+/g, ''),
		// 	this.phoneMask,
		// 	{}
		// ).conformedValue;
		request.mobile = this.editContactForm.controls.mobile.value ? true : false;
		if (this.editContactForm.controls.phoneNumber.value) {
			request.phoneNumber = this.editContactForm.controls.phoneNumber.value.replace(
				/\D+/g,
				""
			);
		}
		request.agencyID = this.editContactForm.controls.collectorCounty.value;
		if (this.editContactForm.controls.mailingAddress.value) {
			request.address = {};
			request.address.line1 = this.editContactForm.controls.mailingAddress.value;
			request.address.stateCode = this.editContactForm.controls.state.value;
			request.address.postalCode = this.editContactForm.controls.zip.value;
			request.address.city = this.editContactForm.controls.city.value;
		}
		//request.dateOfBirth = this.editContactForm.controls.dateOfBirth.value;
		// request.dateOfBirth = conformToMask(
		// 	this.editContactForm.controls.dateOfBirth.value,
		// 	this.mask,
		// 	{}
		// ).conformedValue;
		const dateOfBirth = new DatePipe("en-US").transform(
			this.editContactForm.controls.dateOfBirth.value,
			"yyyy-MM-dd"
		);
		request.dateOfBirth = dateOfBirth;
		this.userDataService
			.callContactInfoApi(
				this.dmvStoreService.sessionGUID,
				this.userStoreService.getUserProfile().megUserGUID,
				request
			)
			.subscribe(
				response => {
					AppUtil.log("callContactInfoApi() ==>", response);
					if (response) {
						this.isloading = false;
						if (response.statusCode === 200) {
							this.userStoreService.outComeText = response.OutcomeText;
							const userProfile = this.userStoreService.getUserProfile();
							userProfile.contactInfo = request;
							this.userStoreService.setUserProfileFromResponse(
								response,
								userProfile
							);
							this.router.navigate(["contact-info"], {
								skipLocationChange: true
							});
						} else {
							this.errorMessage = response.OutcomeText;
							window.scrollTo(0, 0);
						}
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log("login()==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";

						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
}
